export const SET_SENTENCE_DROPDOWN_MENU_OPEN =
  'SET_SENTENCE_DROPDOWN_MENU_OPEN';

export const setSentenceDropdownMenuOpen = (showDropdownMenu: boolean) => ({
  type: SET_SENTENCE_DROPDOWN_MENU_OPEN,
  data: showDropdownMenu,
});
